/**
 * VIP custom site field from owner or public API.
 * **values** is keyed by locale (only installed locales on the restaurant from the API).
 * @see docs/API-REFERENCE.md — restaurant custom site fields
 */
export default class RestaurantCustomSiteField {
  constructor(data = {}) {
    this._uuid = data.uuid ?? data._uuid ?? null
    this._fieldKey = data.field_key ?? data.fieldKey ?? data._fieldKey ?? ''
    // API sends `type`; reactive proxies / plain copies may only expose internal `_type`.
    this._type = data.type ?? data._type ?? 'text'
    const v = data.values ?? data._values ?? {}
    /** @type {Record<string, string>} */
    const values = {}
    if (v && typeof v === 'object' && !Array.isArray(v)) {
      for (const [k, val] of Object.entries(v)) {
        if (typeof val === 'string') values[k] = val
      }
    }
    this._values = values
    this._imageUrl = data.image_url ?? data.imageUrl ?? data._imageUrl ?? null
  }

  get uuid() {
    return this._uuid
  }

  get fieldKey() {
    return this._fieldKey
  }

  get type() {
    return this._type
  }

  get values() {
    return { ...this._values }
  }

  get imageUrl() {
    return this._imageUrl
  }

  static fromApi(row) {
    if (row instanceof RestaurantCustomSiteField) return row
    return new RestaurantCustomSiteField(row ?? {})
  }

  toJSON() {
    return {
      uuid: this._uuid,
      field_key: this._fieldKey,
      type: this._type,
      values: { ...this._values },
      image_url: this._imageUrl,
    }
  }
}
